<h1 mat-dialog-title>Confirmación</h1>
<hr />
<div mat-dialog-content>
  <div fxLayoutAlign="center center">
    <span
      ><b> {{ message }} {{ name }} </b></span
    >
  </div>
</div>
<br />
<div fxLayoutAlign="center center" mat-dialog-actions>
  <button
    [disabled]="clicked"
    clicked="true;"
    mat-raised-button
    color="primary"
    (click)="approve()"
    cdkFocusInitial
  >
    Aprobar
  </button>
  <button
    [disabled]="clicked"
    clicked="true;"
    mat-raised-button
    color="primary"
    (click)="deny()"
    cdkFocusInitial
  >
    Rechazar
  </button>
  <button type="button" mat-raised-button color="warn" (click)="cancel()">
    Cerrar
  </button>
</div>
